import { useEffect } from 'react';
import * as Sentry from '@sentry/react';
import { ConnectedRouter } from 'connected-react-router';
import { Provider } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import 'antd/dist/reset.css';
import 'react-toastify/dist/ReactToastify.css';
import './App.scss';

import { ConfigProvider } from 'antd';
import createStore, { history } from './configureStore';
import Routes from './routes';
import { initLoggers } from './services/loggingService';
import { Theme } from './constants/theme';
import { initAnalytics } from './services/analyticsService';
import { setInitialClientUrl } from './services/userTrackingService';

initLoggers();
const createdStore = createStore(history);
const App = (props) => {
  useEffect(() => {
    initAnalytics();
    setInitialClientUrl();
  }, []);

  return (
    <ConfigProvider theme={{ token: Theme() }}>
      <Provider store={createdStore}>
        <ConnectedRouter history={history}>
          <ToastContainer />
          <Routes {...props} />
        </ConnectedRouter>
      </Provider>
    </ConfigProvider>
  );
};

export default Sentry.withProfiler(App);
